import React from 'react'
import classNames from 'classnames';
import parse from 'html-react-parser';

export default ({onToggle, data, active, id, questionNumber, children}) => {
  const handleChange = () => {
    onToggle(!active, data)
  }

  return (
    <li>
      <input
        className={classNames(
          'custom-checkbox',
          {'active': active}
        )}
        id={`checkbox-${questionNumber}-${id}`}
        type="checkbox"
        value={data.text}
        checked={active}
        onChange={handleChange}
      />
      <label htmlFor={`checkbox-${questionNumber}-${id}`}>{parse(data.text)}</label>
      {children}
    </li>
  )
}
